// fieldLabels.js — central German label map (Req #3 "add a locale").
//
// Single source of truth for raw DB/field keys -> German UI labels. Reused by
// ChangeHistory, detail views, and tables so a field like `delivery_date`
// renders as "Lieferdatum" everywhere. The app is German-only, so this is a
// lightweight label map rather than a full i18n framework.
//
// Unknown keys fall back to the raw key (so nothing silently disappears).

export const FIELD_LABELS = {
  // Auftrag / Order
  order_number: 'Auftragsnr.',
  invoice_number: 'Rechnungsnr.',
  description: 'Beschreibung',
  status: 'Status',
  priority: 'Priorität',
  payment_status: 'Zahlungsstatus',
  print_run: 'Auflage',
  delivery_method: 'Versandart',
  delivery_date: 'Lieferdatum',
  print_date: 'Druckdatum',
  processing_date: 'WV-Datum',
  maschine_name: 'Maschine',
  farbigkeit: 'Farbigkeit',
  notes: 'Notizen',

  // Lieferung / Delivery
  delivered_quantity: 'gel. Menge',
  packaging: 'Verpackung',
  picked_up_by: 'Abgeholt von',
  delivered_on: 'Geliefert am',

  // Papierbestellung / PaperOrder
  supplier: 'Lieferant',
  designation: 'Bezeichnung',
  sheets_gross: 'Bogen (Brutto)',
  sheets_net: 'Bogen (Netto)',
  weight: 'Grammatur',
  price_per_1000: 'Preis / 1000',
  ordered_at: 'Bestellt am',
  delivered_at: 'Geliefert am',

  // Kunde / Customer & Mitarbeiter / User
  name: 'Name',
  vorname: 'Vorname',
  nachname: 'Nachname',
  email: 'E-Mail',
  role: 'Rolle',
  tel: 'Telefon',
  mobil: 'Mobil',
  abteilung: 'Abteilung',
  customer_number: 'Kundennr.',

  // Bookkeeping
  updated_at: 'Aktualisiert am',
  created_at: 'Erstellt am'
}

// Translate a raw field key to its German label (falls back to the key itself).
export function fieldLabel(key) {
  return FIELD_LABELS[key] || key
}
